import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-save-button"
export default class extends Controller {
  static targets = [ 'saveButton' ]

  enable() {
    this.saveButtonTarget.disabled = false
  }
}
